import { useState } from 'react';
import { RunVisit, RunExtract, RunCrawl, RunScrape, RunJson } from '../components/run';
import { LeftNav } from '../components/nav';
import { PillButtons } from '../components/input';

export default function New() {
  const [tab, setTab] = useState('visit');

  return (
    <LeftNav>
      <h2>New job</h2>

      <PillButtons
        value={tab}
        onChange={setTab}
        choices={[
          ['visit', 'Visit'],
          ['extract', 'Extract'],
          ['crawl', 'Crawl'],
          ['scrape', 'Scrape'],
        ]}
      />

      <br />

      <div style={{ border: '1px solid #d0d0d0', borderRadius: 10, padding: 15 }}>
        {tab == 'visit' && <RunVisit />}
        {tab == 'extract' && <RunExtract />}
        {tab == 'crawl' && <RunCrawl />}
        {tab == 'scrape' && <RunScrape />}
        {tab == 'json' && <RunJson />}
      </div>
    </LeftNav>
  );
}
